import reconcilePersistedState from "../../helpers/reconcilePersistedState";

const initialState = {
  paymentPlans: [],
  paymentPlansDynamicData: [],
  selectedPaymentPlanId: -1, // -1 - pay in full, otherwise payment plan id
};

export function paymentPlans(state = initialState, action) {
  switch (action.type) {
    case 'FETCH_LISTING_INFO': {
      // Merge rather than replace: the cart can hold multiple events, and a later listing
      // without plans must not drop plans from an earlier one. Eligibility is filtered by
      // paymentPlansDynamicData.
      const incoming = action.data.paymentPlans || [];
      const incomingIds = new Set(incoming.map((plan) => Number(plan.paymentPlanId)));
      return {
        ...state,
        paymentPlans: [
          ...state.paymentPlans.filter((plan) => !incomingIds.has(Number(plan.paymentPlanId))),
          ...incoming,
        ],
      };
    }
    case 'SET_PAYMENT_PLANS_DYNAMIC_DATA':
      return {
        ...state,
        paymentPlansDynamicData: action.data || [],
      };
    case 'SELECT_PAYMENT_PLAN':
      return {
        ...state,
        selectedPaymentPlanId: action.paymentPlanId,
      };
    case 'RESERVATION_CLEARED':
      return {
        ...state,
        selectedPaymentPlanId: -1,
      }
    case 'RECONCILE_PERSISTED_STATE':
      return reconcilePersistedState(state, initialState);
    default:
      return state;
  }
}
